<template>
  <div>
    <custom-actions show-back :title="title">
      <el-form class="form" v-loading='loading' :model="formData" ref="form" label-width="140px">

        <el-dialog title="发送通知" :visible.sync="sendSmsDialogVisible" width="400px">
          <el-form :model="sendSmsForm" :rules="sendSmsRules" ref="sendSmsFormRef" label-width="80px">
            <el-form-item label="手机号码" prop="mobile">
              <el-input v-model="sendSmsForm.mobile" placeholder="请输入手机号码" style="width: 100%"></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="sendSmsDialogVisible = false">取消</el-button>
            <el-button type="primary" @click="handleSendSms">发送</el-button>
          </div>
        </el-dialog>
        <el-row>
          <el-col :span="12">
            <el-form-item label="客户名称" prop="userId">
              {{ formData.userName || '' }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="品种规格" prop="specId">
              {{ formData.specName || '' }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="是否散油" prop="isBulkOil">

              {{ formData.isBulkOil == '0' ? '否' : formData.isBulkOil == '1' ? '是' : '' }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="ygId" label="关联仓库">
              {{ formData.ygCode || '' }}
            </el-form-item>
          </el-col>
<!--          <el-col :span="12">-->
<!--            <el-form-item prop="jxRatio" label="绩效系数">-->
<!--              {{ formData.jxRatio || '0' }}-->
<!--            </el-form-item>-->
<!--          </el-col>-->
<!--          <el-col :span="12">-->
<!--            <el-form-item label="绩效">-->
<!--              {{Number(parseFloat(formData.trueQuantity * formData.jxRatio).toFixed(2))}}-->
<!--            </el-form-item>-->
<!--          </el-col>-->
          <!-- <el-col :span="12" v-if="recordType == '5'">
            <el-form-item prop="addQuantity" label="出货数量">
              {{ formData.addQuantity || '0' }}
            </el-form-item>
          </el-col> -->
          <el-col :span="12" v-if="recordType !== 'A3'">
            <el-form-item prop="planQuantity" label="计划数量">
              {{ formData.planQuantity || '0' }}
            </el-form-item>
          </el-col>

          <!-- v-if="recordType=='6'||recordType=='1'||recordType=='4'" -->
          <el-col :span="12">
            <el-form-item prop="trueQuantity" label="真实数量">
              {{ formData.trueQuantity || '0' }}
            </el-form-item>
          </el-col>

          <!-- 销售入库与调拨单需要填写租金和是否需要缴纳租金 -->
          <template v-if="['B4', 'A3'].includes(recordType)">
            <el-col :span="12">
              <el-form-item :label="recordType === 'B4' ? '仓储费是否需要缴纳' : '货转费是否需要缴纳'">
                {{ formData.isShippingFee == '1' ? '是' : formData.isShippingFee == '2' ? '否' : '' }}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="recordType === 'B4' ? '仓储费单价' : '货转费单价'">
                {{ formData.shippingFee }}
              </el-form-item>
            </el-col>
          </template>

          <el-col :span="12">
            <el-form-item prop="receiveYgId" v-if="recordType == 'A3'" label="调拨单接收仓库">
              {{ formData.receiveYgCode || '' }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item prop="receiveUserId" v-if="recordType == 'A3'" label="调拨单接收客户">
              {{ formData.receiveUserName || '' }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="ygNotes" v-if="recordType == 'A3'" label="合同编号">
              {{ formData.ygNotes || '' }}
            </el-form-item>
          </el-col>
          <!-- 1  4  6 -->
          <template v-if="recordType !== 'A3'">
            <!-- <el-col :span="12">
              <el-form-item prop="driverName" label="司机姓名">
                {{ formData.driverName || '' }}
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item prop="driverMobile" label="司机手机号">
                {{ formData.driverMobile || '' }}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="vehicleKey" label="车牌号">
                {{ formData.vehicleKey || '' }}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="vehicleGph" label="挂车号">
                {{ formData.vehicleGph || '' }}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="driverKey" label="司机身份证">
                {{ formData.driverKey || '' }}
              </el-form-item>
            </el-col> -->
            <el-col :span="12">
              <el-form-item prop="isVehicle" label="是否需要预约">
                {{ formData.isVehicle == '1' ? '是' : formData.isVehicle == '2' ? '否' : '' }}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="vehicleDateStart" label="预约开始时间">
                {{ formData.vehicleDateStart || '' }}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="vehicleDateEnd" label="预约结束时间">
                {{ formData.vehicleDateEnd || '' }}
              </el-form-item>
            </el-col>
            <!-- <el-col :span="12">
              <el-form-item prop="vehicleDate" label="车辆进厂日期">
                {{ formData.vehicleDate || '' }}
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item prop="vehicleTime" label="车辆进厂时间">
                {{ vehicleTimeTypeMap.get(formData.vehicleTime) || '--' }}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="ygRegion" label="省市区">
                {{ formData.ygRegion || '' }}
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item prop="ygAddress" label="详细地址">
                {{ formData.ygAddress || '' }}
              </el-form-item>
            </el-col> -->
            <!-- <el-col :span="12">
              <el-form-item prop="shippingFee" :label="`运费${formData.isBulkOil === 1 ? '单价' : '总价'}`">
                {{ formData.shippingFee || '0' }}
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item prop="isShippingFee" label="运费是否需要缴纳">
                {{ formData.isShippingFee == '1' ? '是' : formData.isShippingFee == '2' ? '否' : '' }}
              </el-form-item>
            </el-col> -->

            <el-col :span="24">
              <el-form-item prop="ygNotes" label="备注">
                {{ formData.ygNotes || '' }}
              </el-form-item>
            </el-col>

          </template>
          <!-- 调拨单显示附件 -->
          <el-col :span="24">
            <el-form-item label="附件" prop="fileList">
              <file-upload :readonly="true" v-model="formData.fileList" :maxSize="50"></file-upload>
            </el-form-item>
          </el-col>

        </el-row>

        <el-row v-if="recordType !== 'A3'">
          <el-col :span="24">
            <el-form-item label="车辆信息">
              <div v-if="hasAdd" style="display: flex;align-items: center;margin-bottom: 10px;">
                <el-button size="small" type="primary" @click="addVehicle">新增车辆</el-button>
              </div>
              <el-table class="car-list" :data="formData.vehicleList" border style="width: 100%">
                <el-table-column prop="vehicleKey" label="车牌号" width="160">
                  <template v-slot="{ row, $index }">
                    <!-- <el-input v-if="scope.row.edit" v-model="scope.row.vehicleKey" placeholder="请输入车牌号"></el-input> -->
                    <el-form-item :prop="`vehicleList.${$index}.currentVehicleKey`"
                      :rules="[{ required: true, message: '请选择' }]">
                      <el-select v-if="row.edit" v-model="row.currentVehicleKey" @change="val => carChange(val, row)"
                        :filterable="true" :clearable="true" placeholder="请选择车牌号">
                        <el-option v-for="(item, index) of carList" :value="`${item.vehicleKey}(${item.driverName})`"
                          :label="`${item.vehicleKey}(${item.driverName})`" :key="index"></el-option>
                      </el-select>
                      <span v-else>{{ row.vehicleKey }}</span>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column prop="driverName" label="司机姓名" width="160"></el-table-column>
                <el-table-column prop="driverMobile" label="司机手机号" width="160"></el-table-column>
                <el-table-column prop="vehicleGph" label="挂车号" width="160"></el-table-column>
                <el-table-column prop="driverKey" label="司机身份证" width="180"></el-table-column>
                <el-table-column prop="planQuantity" label="计划数量" width="160">
                  <template v-slot="{ row }">
                    <el-input v-if="row.edit" v-model="row.planQuantity" placeholder="请输入计划数量"></el-input>
                    <span v-else>{{ row.planQuantity }}</span>
                  </template>
                </el-table-column>
                <template v-if="recordType === 'B4'">
                  <el-table-column prop="addQuantity" label="发货数量" width="160">
                    <template v-slot="{ row }">
                      <el-input v-if="row.edit" v-model="row.addQuantity" placeholder="请输入发货数量"></el-input>
                      <span v-else>{{ row.addQuantity }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="trueQuantity" label="实收数量" width="160">
                    <template v-slot="{ row }">
                      <el-input v-if="row.edit & formData.isVehicle === '2'" v-model="row.trueQuantity"
                                placeholder="请输入实收数量"></el-input>
                      <span v-else>{{ row.trueQuantity }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="损耗量" width="160">
                    <template v-slot="{ row }">
                      <span>{{ parseFloat((row.addQuantity - row.trueQuantity).toFixed(3)) }}</span>
                    </template>
                  </el-table-column>
                </template>
                <template v-else>
                  <el-table-column prop="addQuantity" label="提货数量" width="160">
                    <template v-slot="{ row }">
                      <el-input v-if="row.edit" v-model="row.addQuantity" placeholder="请输入提货数量"></el-input>
                      <span v-else>{{ row.addQuantity }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="trueQuantity" label="实际出库数量" width="160">
                    <template v-slot="{ row }">
                      <el-input v-if="row.edit & formData.isVehicle === '2'" v-model="row.trueQuantity"
                                placeholder="请输入实际出库数量"></el-input>
                      <span v-else>{{ row.trueQuantity }}</span>
                    </template>
                  </el-table-column>
                </template>

                <el-table-column prop="" label="附件" min-width="380">
                  <template v-slot="{ row }">
                    <file-upload :readonly="!row.edit" v-model="row.fileList"></file-upload>
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="300" fixed="right">
                  <template v-slot="{ row, $index }">
                    <el-button v-if="!row.edit && hasEdit" type="primary" size="mini"
                      @click="editVehicle(row)">编辑</el-button>
                    <el-button v-else type="success" size="small" @click="saveVehicle(row)">保存</el-button>
                    <el-button v-if="hasDel && formData.vehicleList.length > 1" type="danger" size="mini"
                      @click="deleteVehicle(row, $index)">删除</el-button>
                    <el-button type="primary" size="mini" @click="onDownPDF2(row.inoutVehicleId)">导出</el-button>
                    <el-button type="primary" size="mini" @click="showSendSmsDialog(row)">发送通知</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row v-if="isApproval == 1">
          <el-col :span="12">
            <el-form-item prop="nodeResult" label="审批状态">
              <el-tag v-if="formData.nodeResult == '1'">审批通过</el-tag>
              <el-tag type="danger" v-if="formData.nodeResult == '2'">审批驳回</el-tag>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item prop="nodeOpinion" label="审批意见">
              {{ formData.nodeOpinion || '' }}
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item prop="" label="审批记录">
              <el-timeline :reverse="true" placement="top">
                <el-timeline-item placement="top" v-for="(item, index) of formData.recordList" :key="index"
                  :timestamp="item.approveTime || '--'">
                  <el-card>
                    <el-row>
                      <el-col :span="24">
                        审批状态：
                        <el-tag v-if="item.nodeResult == '0'">待审批</el-tag>
                        <el-tag type="success" v-if="item.nodeResult == '1'">审批通过</el-tag>
                        <el-tag type="danger" v-if="item.nodeResult == '2'">审批驳回</el-tag>
                      </el-col>
                      <el-col :span="24">
                        审批节点名称：{{ item.nodeName || '--' }} </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="24" v-if="item.nodeOpinion">
                        审批意见：{{ item.nodeOpinion || '--' }}
                      </el-col>
                    </el-row>

                  </el-card>

                </el-timeline-item>
              </el-timeline>

            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item>
          <!-- <el-button type="primary" v-if="hasBack && formData.inoutStatus === '2'" @click="submitBack">退回</el-button> -->
          <el-button @click="$router.back()" class="global-button">取消</el-button>
          <el-button type="primary" @click="onDownPDF" class="global-button">导出详情</el-button>
          <el-button type="primary" v-if="recordType === 'A3'" @click="onDownPDF3"
            class="global-button">下载货转单</el-button>
        </el-form-item>
      </el-form>
    </custom-actions>

  </div>
</template>

<script>
import { cyRecType, vehicleTimeType } from '@/utils/dict'
import { deepClone } from '@/utils/utils.js'
import { validPhoneNumber } from '@/utils/validator'

export default {
  name: 'CycrkManageDetail',
  data() {
    return {
      cyRecTypeMap: cyRecType,
      vehicleTimeTypeMap: vehicleTimeType,
      loading: false,
      recordType: '',
      formData: {
        userId: '',
        specId: '',
        isBulkOil: '',
        recordType: '',
        inoutType: '',
        addQuantity: '',
        planQuantity: '',
        trueQuantity: '',
        ygId: '',
        receiveYgId: '',
        receiveUserId: '',
        driverName: '',
        driverMobile: '',
        vehicleKey: '',
        vehicleType: '',
        vehicleDate: '',
        vehicleTime: '',
        ygRegion: '',
        ygAddress: '',
        shippingFee: '',
        isShippingFee: '',
        ygNotes: '',
        fileList: [],
        nodeOpinion: '',
        nodeResult: '',
        recordList: [],
        vehicleList: []
      },
      sendSmsDialogVisible: false,
      sendSmsForm: {
        mobile: '',
        inoutVehicleId: ''
      },
      sendSmsRules: {
        mobile: [
          { required: true, message: '请输入手机号码', trigger: 'blur' },
          { pattern: validPhoneNumber, message: '请输入有效的手机号码', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    userInfo() {
      return this.$store.state.user
    },
    inventoryId() {
      return this.$route.query.inventoryId
    },
    // recordType() {
    //   return this.$route.query.recordType
    // },
    isApproval() {
      return this.$route.query.isApproval
    },
    title() {
      const str = this.cyRecTypeMap.get(this.recordType) || '--'
      return str + '详情'
    },
    buttonList() {
      return this.$store.getters.getMenuByCode('CRKGL')
    },
    hasBack() {
      return this.buttonList.includes('back')
    },
    hasAdd() {
      return this.buttonList.includes('addcar')
    },
    hasEdit() {
      return this.buttonList.includes('editcar')
    },
    hasDel() {
      return this.buttonList.includes('deletecar')
    }
  },
  created() {
    if (this.inventoryId) {
      this.loadDetails()
    }
  },
  methods: {
    submitBack() {
      this.$confirm('确认退回吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.$apis.deliveryOrder.bakeYxPickupOrder, {
          inventoryId: this.inventoryId
        }).then(res => {
          this.loadData()
        })
      })
    },
    addVehicle() {
      this.formData.vehicleList.push({
        inoutType: this.formData.inoutType,
        currentVehicleKey: '',
        vehicleKey: '',
        driverName: '',
        driverMobile: '',
        vehicleGph: '',
        driverKey: '',
        planQuantity: '', // 计划数量 新增
        addQuantity: '', // 出货数量 新增
        trueQuantity: '', // 真实数量 查看
        vehicleType: '',
        fileList: [],
        edit: true
      })
    },
    editVehicle(row) {
      // if (this.formData.vehicleList.some(item => item.edit)) {
      //   this.$message({
      //     message: '请先保存当前编辑的车辆',
      //     type: 'warning'
      //   })
      //   return
      // }
      row.edit = true
    },
    saveVehicle(row) {
      if (row.inoutVehicleId) {
        const formData = deepClone(row)
        delete formData.edit
        delete formData.currentVehicleKey
        this.$axios.post(this.$apis.cyCrkManage.updateYgnInoutVehicle, formData).then(res => {
          this.loadDetails()
        })
      } else {
        if (this.inventoryId) {
          const formData = deepClone(row)
          delete formData.edit
          delete formData.currentVehicleKey
          this.$axios.post(this.$apis.cyCrkManage.insertYgnInoutVehicle, {
            ...formData,
            inventoryId: this.inventoryId
          }).then(res => {
            this.loadDetails()
          })
        } else {
          row.edit = false
        }
      }
    },
    deleteVehicle(row, index) {
      if (row.inoutVehicleId) {
        this.$confirm('确认删除该车辆信息, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$axios.post(this.$apis.cyCrkManage.deleteDataYgnInoutVehicle, {
            inoutVehicleId: row.inoutVehicleId
          }).then(res => {
            this.loadDetails()
          })
        })
      } else {
        this.formData.vehicleList.splice(index, 1)
      }
    },
    carChange(val, row) {
      const carInfo = this.carList.find(item => item.currentVehicleKey === val)
      if (carInfo) {
        row.vehicleKey = carInfo.vehicleKey
        row.driverName = carInfo.driverName
        row.driverMobile = carInfo.driverMobile
        row.driverKey = carInfo.driverKey
        row.vehicleGph = carInfo.vehicleGph
        if (row.planType === '1') {
          row.vehicleType = '1'
        } else { // planType为2
          row.vehicleType = row.isOiltanker === '0' ? '2' : '3'
        }
      } else {
        row.vehicleKey = ''
        row.driverName = ''
        row.driverMobile = ''
        row.driverKey = ''
        row.vehicleGph = ''
        row.vehicleType = ''
      }
    },
    loadCarList() {
      console.log('typeof', typeof this.formData.isBulkOil)
      this.$axios.get(this.$apis.carManage.selectWlVehicleInfoByPage, {
        planType: this.formData.isBulkOil === 1 ? '2' : '1'
      }).then(res => {
        this.carList = res.list.map(item => {
          return {
            currentVehicleKey: `${item.vehicleKey}(${item.driverName})`,
            ...item
          }
        })
      })
    },
    onDownPDF() {
      const loadingInstance = this.$loading({
        text: '正在导出...',
        background: 'rgba(0, 0, 0, 0.8)'
      })
      this.$axios.post(this.$apis.cyCrkManage.txYgnInoutVehiclePdf, {
        inventoryId: this.inventoryId
      }, {
        responseType: 'blob'
      }).then(res => {
        if (res) {
          const contentDisposition = res.headers['content-disposition']

          let fileName = '出库确认单.pdf'

          if (contentDisposition) {
            // 匹配 filename="xxx.pdf"
            const fileNameMatch = contentDisposition.match(/filename="(.+)"/)
            if (fileNameMatch && fileNameMatch[1]) {
              fileName = fileNameMatch[1] // 拿到 ZJ202603291451445378.pdf
            }
          }
          // const fileName = disposition.substring(disposition.indexOf('filename')).split('=')[1]
          console.log('fileName', fileName)
          this.downloadFile(res.data, fileName)
        }
      }).catch(error => {
        console.error('导出失败:', error)
      }).finally(() => {
        loadingInstance.close()
      })
    },
    onDownPDF2(inoutVehicleId) {
      const loadingInstance = this.$loading({
        text: '正在导出...',
        background: 'rgba(0, 0, 0, 0.8)'
      })
      this.$axios.post(this.$apis.cyCrkManage.txYgnInoutVehiclePdf2, {
        inoutVehicleId: inoutVehicleId
      }, {
        responseType: 'blob'
      }).then(res => {
        if (res) {
          const contentDisposition = res.headers['content-disposition']

          let fileName = '出入库单据.pdf'

          if (contentDisposition) {
            // 匹配 filename="xxx.pdf"
            const fileNameMatch = contentDisposition.match(/filename="(.+)"/)
            if (fileNameMatch && fileNameMatch[1]) {
              fileName = fileNameMatch[1] // 拿到 ZJ202603291451445378.pdf
            }
          }
          // const fileName = disposition.substring(disposition.indexOf('filename')).split('=')[1]
          console.log('fileName', fileName)
          this.downloadFile(res.data, fileName)
        }
      }).catch(error => {
        console.error('导出失败:', error)
      }).finally(() => {
        loadingInstance.close()
      })
    },
    onDownPDF3() {
      this.$msgbox({
        title: '模板选择',
        message: `
          <div style="margin:15px 0;">
            <label style="margin-right:20px;">
              <input type="radio" name="template" value="1" checked> 长江集团模板
            </label>
            <label>
              <input type="radio" name="template" value="2"> 仓储公司模板
            </label>
          </div>
        `,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        dangerouslyUseHTMLString: true, // 允许渲染HTML
        callback: (action, instance) => {
          // 点击确定时获取选中的值
          if (action === 'confirm') {
            // 获取选中的单选值
            const selected = document.querySelector('input[name="template"]:checked').value
            const loadingInstance = this.$loading({
              text: '正在导出...',
              background: 'rgba(0, 0, 0, 0.8)'
            })
            this.$axios.post(this.$apis.cyCrkManage.txYgnInoutVehiclePdfHz, {
              inventoryId: this.inventoryId,
              dyType: selected
            }, {
              responseType: 'blob'
            }).then(res => {
              if (res) {
                const contentDisposition = res.headers['content-disposition']
                let fileName = '货转单.pdf'
                if (contentDisposition) {
                  // 匹配 filename="xxx.pdf"
                  const fileNameMatch = contentDisposition.match(/filename="(.+)"/)
                  if (fileNameMatch && fileNameMatch[1]) {
                    fileName = fileNameMatch[1] // 拿到 ZJ202603291451445378.pdf
                  }
                }
                console.log('fileName', fileName)
                this.downloadFile(res.data, fileName)
              }
            }).catch(error => {
              console.error('导出失败:', error)
            }).finally(() => {
              loadingInstance.close()
            })
          }

          // 点击取消
          if (action === 'cancel') {
            this.$message({
              type: 'info',
              message: '取消选择'
            })
          }
        }
      })
    },
    downloadFile(data, fileName) {
      const blob = new Blob([data], { type: 'application/pdf' })
      const downloadElement = document.createElement('a')
      // 创建下载的链接
      const href = window.URL.createObjectURL(blob)
      downloadElement.href = href
      // 下载后文件名
      console.log('decodeURIComponent(fileName)', decodeURIComponent(fileName))
      downloadElement.download = decodeURIComponent(fileName)
      document.body.appendChild(downloadElement)
      downloadElement.click()
      document.body.removeChild(downloadElement)
      // 释放掉blob对象
      window.URL.revokeObjectURL(href)
    },
    loadDetails() {
      this.loading = true
      this.$axios.get(this.$apis.cyCrkManage.selectYgnInoutRecordByInventoryId, {
        inventoryId: this.inventoryId
      }).then(res => {
        this.recordType = res.recordType

        // 给车辆列表添加edit属性用于编辑
        if (res.vehicleList && res.vehicleList.length > 0) {
          res.vehicleList.forEach(item => {
            item.edit = false
            item.currentVehicleKey = `${item.vehicleKey}(${item.driverName})`
          })
        }
        res.fileList = res.fileList ? res.fileList : []
        res.recordList = res.recordList ? res.recordList : []
        this.formData = res
        this.loadCarList()
      }).finally(() => {
        this.loading = false
      })
    },
    showSendSmsDialog(row) {
      this.sendSmsForm = {
        mobile: '',
        inoutVehicleId: row.inoutVehicleId
      }
      this.sendSmsDialogVisible = true
    },
    handleSendSms() {
      this.$refs.sendSmsFormRef.validate((valid) => {
        if (valid) {
          this.$axios.post(this.$apis.cyCrkManage.sendYgnInoutVehicleSms, {
            inoutVehicleId: this.sendSmsForm.inoutVehicleId,
            mobile: this.sendSmsForm.mobile
          }).then(res => {
            // this.$message.success('发送成功')
            this.sendSmsDialogVisible = false
          }).catch(() => {
            this.$message.error('发送失败')
          })
        }
      })
    }
  }
}
</script>

<style scoped lang='scss'>
.del-btn {
  color: red;
}

.car-list {

  .el-select,
  .el-input {
    width: 100%;
  }
}

.el-select,
.el-input,
.el-cascader,
.el-radio-group,
.el-input-number {
  width: 400px;
}

.row-wrap {
  display: flex;
  flex-wrap: wrap;
}

.images-wrap {
  width: 148px;
  height: 148px;
  border: 1px dotted #ddd;
  border-radius: 10px;
  position: relative;
  margin-right: 14px;

  .close-icon {
    position: absolute;
    top: 0;
    right: 0;
    transform: translate(50%, -50%);
    z-index: 10;
    font-size: 18px;
    color: red;
    cursor: pointer;
  }
}
</style>
